<template>
  <select-button-with-assignee-mandates
    v-if="hasAssigneeMandates"
    v-model="internalSelectedID"
    :is-disabled="isDisabled"
    :statuses="statuses"
    :size="size"
    :job-info="jobInfo"
  />
  <select-button
    v-else
    v-model="internalSelectedID"
    :is-disabled="isDisabled"
    :options="statuses"
    :size="size"
    title="Status"
  />
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import { IStatusForSelection } from '@/api/types/response.types'
import { IJobInfo } from '@/types/data-objects/items'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'StatusPicker',

  props: {
    selectedId: {
      type: Number,
      default: null,
    },
    statuses: {
      type: Array as () => IStatusForSelection[],
      default: (): IStatusForSelection[] => [],
    },
    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },
    size: {
      type: String,
      default: 'small',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:selectedId'],

  computed: {
    internalSelectedID: {
      get(): number {
        return this.selectedId
      },
      set(newValue: number) {
        this.$emit('update:selectedId', newValue)
      },
    },
    hasAssigneeMandates(): boolean {
      return this.jobInfo && this.jobInfo.assigneeMandates.length > 0
    },
    selectedStatus(): IStatusForSelection {
      return this.statuses.find(item => item.id === this.selectedId)
    },
    selectedName(): string {
      /* May be undefined at moment status is updated on task/convo detail, so check first...*/
      if (this.selectedStatus) {
        return this.selectedStatus.name
      }
      return ''
    },
  },
})
</script>
